export enum EFiltersMobileTestId {
  Panel = 'FiltersMobile_Panel',
  Modal = 'FiltersMobile_Modal',
  Apply = 'FiltersMobile_Apply',
  SaveSearchButton = 'FiltersMobile_SaveSearchButton',

  RegionFilterModal = 'FiltersMobile_RegionFilterModal',
  RegionFilterModalClose = 'FiltersMobile_RegionFilterModalClose',

  DateFilterInput = 'FiltersMobile_DateFilterInput',
  DateFilterModal = 'FiltersMobile_DateFilterModal',
  DateFilterModalClose = 'FiltersMobile_DateFilterModalClose',

  GuestsFilterInput = 'FiltersMobile_GuestsFilterInput',
  GuestsFilterPlus = 'FiltersMobile_GuestsFilterPlus',
  GuestsFilterMinus = 'FiltersMobile_GuestsFilterMinus',

  KidsFilterCheckbox = 'FiltersMobile_KidsFilterCheckbox',
  PetsFilterCheckbox = 'FiltersMobile_PetsFilterCheckbox',

  PriceMinFilterInput = 'FiltersMobile_PriceMinFilterInput',
  PriceMaxFilterInput = 'FiltersMobile_PriceMaxFilterInput',
}
